import React from "react";
import { Typography } from "@mui/material";

import { StyledGridStack } from "./styles";

export const PurchaseOrderLabel = ({
  label = "",
  value = "",
  valueBold = false,
  underlined = false,
  c1 = "100px",
  autoSpacing = false,
  ...rest
}) => {
  const valueSx = underlined ? { borderBottom: "1px solid" } : {};
  const fontSize = "11px";

  return (
    <StyledGridStack {...rest}>
      <Typography
        variant="boldCaption"
        className="PurchaseOrderLabel-label"
        fontWeight={400}
        lineHeight="14px"
        fontSize={fontSize}
      >
        {label}
      </Typography>
      <Typography
        variant={valueBold ? "boldCaptionL" : "caption"}
        className="PurchaseOrderLabel-value"
        lineHeight="14px"
        sx={valueSx}
        fontSize={fontSize}
        noWrap
      >
        {value}
      </Typography>
    </StyledGridStack>
  );
};

export default PurchaseOrderLabel;
